import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import {
  Home,
  User,
  FileText,
  FolderKanban,
  Mail,
  Github,
  Linkedin,
} from "lucide-react";

const Navigation: React.FC = () => {
  return (
    <NavigationStyled>
      <div className="nav-header">
        <h3 className="logo">SA</h3>
        <p className="tagline">Software Engineer</p>
      </div>

      <ul className="nav-items">
        <li>
          <NavLink
            to="/"
            end
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            <Home size={18} />
            <span>Home</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            <User size={18} />
            <span>About</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/resume"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            <FileText size={18} />
            <span>Resume</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/projects"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            <FolderKanban size={18} />
            <span>Projects</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            <Mail size={18} />
            <span>Contact</span>
          </NavLink>
        </li>
      </ul>

      <div className="nav-footer">
        <div className="social-links">
          <a
            href="https://github.com/saifaldin14"
            target="_blank"
            rel="noreferrer"
            title="GitHub"
          >
            <Github size={18} />
          </a>
          <a
            href="https://www.linkedin.com/in/saif-al-din-ali-78b061182/"
            target="_blank"
            rel="noreferrer"
            title="LinkedIn"
          >
            <Linkedin size={18} />
          </a>
        </div>
        <p className="copyright">
          &copy; 2026 <strong>Saif Al-Din Ali</strong>
        </p>
      </div>
    </NavigationStyled>
  );
};

const NavigationStyled = styled.nav`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .nav-header {
    padding: 2rem 1.5rem;
    border-bottom: 1px solid var(--border-color);
    text-align: center;

    .logo {
      font-size: 1.75rem;
      font-weight: 800;
      letter-spacing: -0.02em;
      background: linear-gradient(
        135deg,
        var(--primary-color),
        var(--primary-color-light)
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-bottom: 0.25rem;
    }

    .tagline {
      font-size: 0.75rem;
      color: var(--font-light-color);
      text-transform: uppercase;
      letter-spacing: 0.1em;
      font-weight: 500;
    }
  }

  .nav-items {
    flex: 1;
    padding: 1.5rem 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    li {
      .nav-link {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.7rem 1rem;
        border-radius: 10px;
        font-size: 0.9rem;
        font-weight: 500;
        color: var(--font-light-color);
        transition: all 0.2s ease;
        position: relative;

        svg {
          flex-shrink: 0;
          transition: color 0.2s ease;
        }

        &:hover {
          color: var(--white-color);
          background: var(--background-light-color-2);
        }

        &.active {
          color: white;
          background: var(--primary-color);
          font-weight: 600;

          svg {
            color: white;
          }
        }
      }
    }
  }

  .nav-footer {
    padding: 1.25rem 1.5rem;
    border-top: 1px solid var(--border-color);

    .social-links {
      display: flex;
      justify-content: center;
      gap: 0.75rem;
      margin-bottom: 1rem;

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.25rem;
        height: 2.25rem;
        border-radius: 8px;
        border: 1px solid var(--border-color);
        color: var(--font-light-color);
        transition: all 0.2s ease;

        &:hover {
          border-color: var(--primary-color);
          color: var(--primary-color);
          background: var(--background-light-color-2);
        }
      }
    }

    .copyright {
      font-size: 0.7rem;
      text-align: center;
      color: var(--font-light-color);

      strong {
        color: var(--white-color);
        font-weight: 600;
      }
    }
  }
`;

export default Navigation;
